module.exports = __webpack_public_path__ + "static/media/sb-profile-picture.cfcad64f.jpg";